import { render, staticRenderFns } from "./FacebookSimple.vue?vue&type=template&id=7e6b1cd0"
import script from "./FacebookSimple.vue?vue&type=script&lang=js"
export * from "./FacebookSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports